module.exports = __webpack_public_path__ + "img/padlock-image.8b72ab5b.svg";